// Downloads a users list as CSV: the rows on screen, in the order shown, plus contact details.
import { Download } from "lucide-react";
import { Button } from "@/components/ui/button";
import { downloadText } from "@/lib/download";

// Same rule as the backend's csv_safe: formula-looking text gets a leading ' (numbers pass through).
const TRIGGERS = /^[=+\-@\t\r]/;
const NUMERIC = /^[+-]?\d[\d,.\s]*$/;
const cell = (v) => {
  let s = v == null ? "" : String(v);
  if (s.length > 1 && TRIGGERS.test(s) && !NUMERIC.test(s)) s = `'${s}`;
  return /[",\r\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};
const pad = (n) => String(n).padStart(2, "0");
const when = (iso) => {
  const d = iso ? new Date(iso) : null;
  if (!d || Number.isNaN(d.getTime())) return "";
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

export const USER_CSV = {
  name: ["Name", (u) => u.name],
  email: ["Email", (u) => u.email],
  phone: ["Phone", (u) => u.phone],
  organization: ["Organization", (u) => u.organization_name],
  team: ["Team", (u) => (u.teams?.length ? u.teams.join(", ") : u.team)],
  role: ["Role", (u) => u.role_label || u.role],
  status: ["Status", (u) => (u.status ? u.status[0].toUpperCase() + u.status.slice(1) : "")],
  last_login: ["Last sign-in", (u) => when(u.last_login) || "Never"],
  mfa: ["2FA", (u) => (u.mfa_enabled ? "On" : u.mfa_required ? "Required" : "Off")],
  welcome: ["Welcome sent", (u) => when(u.welcome_sent_at)],
};

const slug = (s) => (s || "users").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "") || "users";

export function usersCsv(rows, columns) {
  const cols = columns.map((k) => USER_CSV[k]);
  const lines = [cols.map(([h]) => cell(h)), ...rows.map((u) => cols.map(([, f]) => cell(f(u))))];
  return lines.map((l) => l.join(",")).join("\r\n");
}

export function UsersCsvButton({ rows, columns, name, testid }) {
  const download = () => {
    const stamp = new Date().toISOString().slice(0, 10);
    downloadText(`\ufeff${usersCsv(rows, columns)}`, `${slug(name)}-users-${stamp}.csv`);
  };
  return (
    <Button type="button" size="sm" variant="outline" className="h-8 shrink-0" disabled={!rows.length}
            onClick={download} data-testid={testid} title="Download this list as CSV, in the order shown">
      <Download className="h-3.5 w-3.5" /> CSV
    </Button>
  );
}
